// src/components/Vendors/ShowMoreVendors.js
import React, { useContext } from 'react';
import VariousVendorCards from './VariousVendorCards'; // Assuming this component exists
import { SearchContext } from '../../context/SearchContext';

const ShowMoreVendors = ({ onShowPopup }) => {
    const context = useContext(SearchContext);

    // Safety check: Don't render anything if context is not ready
    if (!context) {
        return null;
    }

    const { vendorResults, vendorTotalResults, fetchMoreVendors, loadingMore } = context;

    // Do not show the component if a search hasn't been performed yet.
    if (!context.searchVendorSended) {
        return null;
    }

    return (
        <div className="accordeon__el">
            <div className="accordeon__content">
                {/* This component displays the cards */}
                <VariousVendorCards vendors={vendorResults} onShowPopup={onShowPopup} />

                {/* Conditionally render the "Show More" button */}
                {vendorResults.length < vendorTotalResults && (
                    <li className="show-all">
                        <div className="container">
                            <button onClick={fetchMoreVendors} disabled={loadingMore}>
                                {loadingMore ? 'Loading...' : `Show More Vendors • ${vendorTotalResults - vendorResults.length}`}
                            </button>
                        </div>
                    </li>
                )}
            </div>
        </div>
    );
};

export default ShowMoreVendors;